import { render, staticRenderFns } from "./customPreview.vue?vue&type=template&id=6e2a0d38&scoped=true"
import script from "./customPreview.vue?vue&type=script&lang=js"
export * from "./customPreview.vue?vue&type=script&lang=js"
import style0 from "./customPreview.vue?vue&type=style&index=0&id=6e2a0d38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a0d38",
  null
  
)

export default component.exports